import { IconChevronRight } from 'featherico';
import { map, truncate } from 'lodash/fp';
import { Fragment } from 'react';
import { BASE } from '../../../routes';
import { preventJavascriptUrls } from '../../../services/security';
import Tooltip from '../Tooltip';
import styles from './style.m.less';

type PathFragment = {
    label: string;
    url?: string;
    prependBaseUrl?: boolean;
};

type Props = {
    path: PathFragment[];
};

const TRUNCATE_LENGTH = 45;
const withTooltip = (element: React.ReactNode, tooltip: React.ReactNode) => (
    <Tooltip tooltip={tooltip} position="bottom">
        {element}
    </Tooltip>
);

export default function Breadcrumbs(props: Props) {
    return (
        <ul className={styles.container}>
            {map(
                item => (
                    <Breadcrumb {...item} key={item.label} />
                ),
                props.path
            )}
        </ul>
    );
}

function Breadcrumb({ prependBaseUrl, url, label }: PathFragment) {
    const isLong = label.length > TRUNCATE_LENGTH;
    const displayLabel = isLong ? truncate({ length: TRUNCATE_LENGTH }, label) : label;

    const contentProps = {
        prependBaseUrl,
        url,
        displayLabel,
    };
    return (
        <li>
            {isLong ? (
                withTooltip(<BreadcrumbContent {...contentProps} />, label)
            ) : (
                <BreadcrumbContent {...contentProps} />
            )}
        </li>
    );
}

function BreadcrumbContent({
    prependBaseUrl,
    url,
    displayLabel,
}: {
    prependBaseUrl?: boolean;
    url?: string;
    displayLabel: string;
}) {
    return url ? (
        <Fragment>
            <a href={preventJavascriptUrls(`${prependBaseUrl ? BASE : ''}${url}`)}>{displayLabel}</a>
            <IconChevronRight className={styles.chevron} />
        </Fragment>
    ) : (
        <span>{displayLabel}</span>
    );
}
